/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useLayoutEffect, useRef } from "react";
import { useGLTF } from "@react-three/drei";
import * as THREE from "three";
import { useFrame } from "@react-three/fiber";
import useStore, { audio, playAudio } from "../store";
import { degToRad } from "three/src/math/MathUtils";

export default function Tank(props) {
  const { nodes, materials } = useGLTF("https://web-cdn.tankionline.com/new-year/models/tank/tank.glb");
  const mesh = React.useRef();
  const sound = useStore((state) => state.sound);
  const cell = useStore((state) => state.i) - 1;
  const i = cell === -1 ? -1 : cell - Math.floor(cell / 17) * 17;
  const startMove = useStore((state) => state.startMove);
  const stopMove = useStore((state) => state.stopMove);
  const start_cell = cell === -1;

  useLayoutEffect(() => {
    if (start_cell) {
      mesh.current.rotation.y = degToRad(90);
      mesh.current.position.x = 0;
      mesh.current.position.z = 167;
      mesh.current.position.y = 2;
    } else {
      mesh.current.rotation.y = degToRad((360 / 17) * i);
      mesh.current.position.x = 150 * Math.sin(degToRad((360 / 17) * i));
      mesh.current.position.z = 150 * Math.cos(degToRad((360 / 17) * i));
      mesh.current.position.y = 0;
    }
  }, [start_cell]);

  let lerpway = 0;
  const newPoint = new THREE.Vector3(
    150 * Math.sin(degToRad((360 / 17) * i)),
    0,
    150 * Math.cos(degToRad((360 / 17) * i))
  );
  let rotationAngle = (((360 / 17) * i) + (360 * Math.floor(cell / 17)))

  useFrame((state, delta) => {
    if (startMove) {
      if (sound) {
        playAudio(audio.move, 0.4);
      }
      mesh.current.position.lerp(newPoint, delta * 0.5 * lerpway);
      mesh.current.rotation.yD = THREE.MathUtils.lerp(
        mesh.current.rotation.yD || rotationAngle,
        rotationAngle,
        0.05
      );
      mesh.current.rotation.y = THREE.Math.degToRad(mesh.current.rotation.yD);
      lerpway++;
      if (lerpway === 115) {
        stopMove();
      }
    }
  });
  return (
    <group ref={mesh} {...props} dispose={null} position={[0, 0, 150]}>
      <mesh geometry={nodes.Fishka001.geometry} material={materials.Fishka} />
    </group>
  );
}

useGLTF.preload("https://web-cdn.tankionline.com/new-year/models/tank/tank.glb");
